import { useState, useEffect } from "react"
import "./credentials.scss"
import { useNavigate } from "react-router-dom"
import CredentialsPopUp from "../../components/credentialsPopUp/CredentialsPopUp"
import Home from "../home/Home"

const Credentials = ({children}) => {
    const url = window.location.pathname;
    const navigate = useNavigate();
    
    const [unlocked, setUnlocked] = useState(false)
    
    useEffect(() => {
        const checkAccess = async () => {
            const storedProjectsStr = localStorage.getItem('allowed_projects');
            if (storedProjectsStr) {
                try {
                    const allowedProjects = JSON.parse(storedProjectsStr);
                    // allow if url is in the list, or if user is admin (has /dashboard)
                    if (allowedProjects.includes(url) || allowedProjects.includes("/dashboard")) {
                        setUnlocked(true);
                    } else {
                        setUnlocked(false);
                    }
                } catch(e) {
                    setUnlocked(false);
                }
            } else {
                setUnlocked(false);
            }
        };

        checkAccess();
    }, [url]);

    if (unlocked) {
        return(
            children
        )
    } else {
        return (
            <div>
                <Home/>
                <div className="credentialsContainer ask">
                    <div className="credentialBG" onClick={() => navigate("/")}/>
                    <div className="credentials"><CredentialsPopUp/></div>
                </div>
            </div>
        )
    }
}

export default Credentials;